/**
 * RF-13 · Filtros activos del dashboard.
 *
 * Store de solo UI: no habla con el API. Mantiene la selección de periodo, área y
 * severidad para que sobreviva a la navegación entre pestañas del tablero.
 *
 * Store Pinia: estado compartido del módulo y orquestación de sus servicios.
 * Las vistas no llaman a `http` ni a los servicios directamente; pasan por aquí.
 * Los servicios no lanzan, así que las acciones interpretan valores neutros
 * (`[]`, `null`, `false`) como fallo.
 */

import { defineStore } from 'pinia'

/**
 * RF-13 · Filtros persistentes del dashboard (se recuerdan por usuario en
 * localStorage vía pinia-plugin-persistedstate, ya instalado).
 */
export const useDashboardFiltros = defineStore('dashboardFiltros', {
  state: () => ({
    idEjecucion: null as number | null,
    // Filtros del calendario
    calTipo: '' as string,
    calVista: 'mes' as 'mes' | 'agenda'
  }),
  persist: true
})

export default useDashboardFiltros
